import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';

import {
  PlaceholderText,
  QueryFieldButton,
  QueryFieldText,
} from './MobileSearchQueryField.styled';

type Props = {
  query?: string;
  location?: string;
  showSearchContext: boolean;
  onClick: () => void;
};

export function MobileSearchQueryField({
  query,
  location,
  showSearchContext,
  onClick,
}: Props) {
  const { i18n } = useI18n();

  const displayText = showSearchContext
    ? [query ? `"${query}"` : null, location].filter(Boolean).join(', ')
    : '';

  return (
    <QueryFieldButton
      type="button"
      aria-label={i18n('Open search')}
      data-qa-id="search-menu-button"
      onClick={onClick}
    >
      <Icon name="search" size={16} colorName="mediumContentGrey" />
      {displayText ? (
        <QueryFieldText>{displayText}</QueryFieldText>
      ) : (
        <PlaceholderText>{i18n('Volunteer or find a job')}</PlaceholderText>
      )}
    </QueryFieldButton>
  );
}
